export const employmentReducer = (state = { loading: false, leaveRequests: [], employmentError: null }, action) => {
    switch (action.type) {
        case 'EMPLOYMENT_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'LEAVE_REQUESTS_SUCCESS':
            return {
                ...state,
                loading: false,
                leaveRequests: action.payload
            }
        case 'LEAVE_REQUEST_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                leaveRequests: [action.payload, ...state.leaveRequests]
            }
        case 'LEAVE_REQUEST_DELETE_SUCCESS':
            return {
                ...state,
                loading: false,
                leaveRequests: state.leaveRequests.filter(r => String(r._id) !== String(action.payload))
            }
        case 'EMPLOYMENT_ERROR':
            return {
                ...state,
                loading: false,
                employmentError: action.payload
            }
        default:
            return state
    }
}
